import script from "./InsuranceClaims.vue?vue&type=script&setup=true&lang=ts"
export * from "./InsuranceClaims.vue?vue&type=script&setup=true&lang=ts"

import "./InsuranceClaims.vue?vue&type=style&index=0&id=a0adfc2a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0adfc2a"]])

export default __exports__